import { render, staticRenderFns } from "./LevelStart.vue?vue&type=template&id=51fee476&scoped=true"
import script from "./LevelStart.vue?vue&type=script&lang=js"
export * from "./LevelStart.vue?vue&type=script&lang=js"
import style0 from "./LevelStart.vue?vue&type=style&index=0&id=51fee476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fee476",
  null
  
)

export default component.exports